/* Rheal PDP hero + sale banner behaviour. Idempotent; re-inits on theme-editor section reloads. */
(function () {
  var pad = function (n) { return String(n).padStart(2, '0'); };

  // Current time in the UK, as {h, m, s} — dispatch cut-off and "daily" sale timers run on UK time.
  function ukNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
    var o = {}; parts.forEach(function (p) { o[p.type] = parseInt(p.value, 10); });
    return { h: o.hour % 24, m: o.minute, s: o.second };
  }
  // Seconds left until a timer ends. mode "daily" = midnight UK; otherwise an ISO-ish date "2026-10-31 23:59".
  function secondsLeft(mode, endText) {
    if (mode === 'fixed' && endText) {
      var t = Date.parse(endText.trim().replace(' ', 'T'));
      if (!isNaN(t)) return Math.max(0, Math.floor((t - Date.now()) / 1000));
    }
    var n = ukNow();
    return 86400 - (n.h * 3600 + n.m * 60 + n.s);
  }
  function hms(t) { return pad(Math.floor(t / 3600)) + ':' + pad(Math.floor(t % 3600 / 60)) + ':' + pad(t % 60); }

  /* ---------- Sale banner ---------- */
  function initBanner(root) {
    if (root.dataset.rsbInit) return; root.dataset.rsbInit = '1';
    var mode = root.dataset.mode, end = root.dataset.end, hide = root.dataset.hide === 'true';
    var hh = root.querySelector('[data-hh]'), mm = root.querySelector('[data-mm]'), ss = root.querySelector('[data-ss]');
    function tick() {
      var t = secondsLeft(mode, end);
      if (hh) { hh.textContent = pad(Math.floor(t / 3600)); mm.textContent = pad(Math.floor(t % 3600 / 60)); ss.textContent = pad(t % 60); }
      if (t <= 0 && hide && !(window.Shopify && window.Shopify.designMode)) root.style.display = 'none';
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Hero ---------- */
  function initHero(root) {
    if (root.dataset.rphInit) return; root.dataset.rphInit = '1';

    // Gallery
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots = root.querySelectorAll('[data-dot]');
    var strip = root.querySelector('[data-thumbs]');
    var counter = root.querySelector('[data-counter]');
    var n = slides.length, i = 0;
    function go(k) {
      if (!n) return;
      i = (k + n) % n;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
      var btn = thumbs[i];
      if (strip && btn) strip.scrollTo({ left: btn.offsetLeft - strip.offsetLeft - strip.clientWidth / 2 + btn.offsetWidth / 2, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); }); });
    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    var stage = root.querySelector('[data-stage]'), sx = null, sy = 0;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; });
      stage.addEventListener('pointercancel', function () { sx = null; });
      stage.addEventListener('pointerup', function (e) {
        if (sx == null) return;
        var dx = e.clientX - sx, dy = e.clientY - sy; sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? i + 1 : i - 1);
      });
    }

    // Plan selector
    var plans = root.querySelectorAll('[data-plan]');
    function pick(el) {
      plans.forEach(function (p) { var on = p === el; p.classList.toggle('is-active', on); var r = p.querySelector('input'); if (r) r.checked = on; });
    }
    plans.forEach(function (p) {
      var r = p.querySelector('input');
      if (r) r.addEventListener('change', function () { if (r.checked) pick(p); });
      p.addEventListener('click', function () { pick(p); });
    });

    // Ship-by line: counts down to the UK dispatch cut-off, then flips to "tomorrow"
    var ship = root.querySelector('[data-ship]');
    var shipDay = root.querySelector('[data-ship-day]'), shipIn = root.querySelector('[data-ship-in]');
    var cut = parseInt(root.dataset.cutoff || '15', 10);
    var dToday = root.dataset.today || 'today', dTomorrow = root.dataset.tomorrow || 'tomorrow';
    // Scarcity timer
    var endsEl = root.querySelector('[data-ends]');
    function tick() {
      if (ship) {
        var u = ukNow(), now = u.h * 3600 + u.m * 60 + u.s, c = cut * 3600;
        var before = now < c, left = before ? c - now : (86400 - now) + c;
        shipDay.textContent = before ? dToday : dTomorrow;
        shipIn.textContent = Math.floor(left / 3600) + 'hr ' + Math.floor(left % 3600 / 60) + 'mins';
      }
      if (endsEl) endsEl.textContent = hms(secondsLeft(root.dataset.endMode, root.dataset.end));
    }
    tick(); setInterval(tick, 1000);

    // Add to cart
    var cta = root.querySelector('[data-cta]'), err = root.querySelector('[data-error]');
    // Back from checkout can restore this page from the bfcache mid-submit; clear the loading state
    if (cta) window.addEventListener('pageshow', function (e) {
      if (e.persisted) { cta.removeAttribute('aria-busy'); cta.disabled = false; }
    });
    if (cta) cta.addEventListener('click', function (e) {
      e.preventDefault();
      if (cta.getAttribute('aria-busy') === 'true') return;
      var p = root.querySelector('[data-plan].is-active') || plans[0];
      if (!p) return;
      var v = p.dataset.variant;
      // Paid product blocks wired to this card
      var extras = [];
      try { extras = JSON.parse(p.dataset.items || '[]'); } catch (x) { extras = []; }
      if (!v && !extras.length) { if (err) err.textContent = root.dataset.msgUnbound || 'This offer isn’t connected to a product yet.'; return; }
      var items = [];
      if (v) {
        var main = { id: parseInt(v, 10), quantity: parseInt(p.dataset.qty || '1', 10) };
        if (p.dataset.sellingPlan) main.selling_plan = parseInt(p.dataset.sellingPlan, 10);
        items.push(main);
      }
      items = items.concat(extras);
      // Free gifts: once each, even if a variant is both typed on the card and picked on a freebie row
      var seen = {};
      (p.dataset.gifts || '').split(',').forEach(function (g) { g = g.trim(); if (/^\d+$/.test(g) && !seen[g]) { seen[g] = 1; items.push({ id: parseInt(g, 10), quantity: 1 }); } });
      cta.setAttribute('aria-busy', 'true'); cta.disabled = true; if (err) err.textContent = '';
      var after = root.dataset.after || 'checkout';
      var code = (p.dataset.discount || '').trim();
      var fresh = root.dataset.clear === 'true';
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
      var ok = function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); };
      // A /discount/<code> link (ads, emails, the old button) leaves a discount_code cookie that
      // checkout re-applies on top of the cart's codes, so expire it along with the cart
      if (fresh) ['', '; domain=' + location.hostname, '; domain=.' + location.hostname.split('.').slice(-2).join('.')].forEach(function (d) {
        document.cookie = 'discount_code=; Max-Age=0; path=/' + d;
      });
      // "Empty the cart first" (section setting): only the chosen offer and its gifts reach checkout
      var emptyFirst = fresh
        ? fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        : Promise.resolve();
      emptyFirst
        .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: items }) }).then(ok); })
        .then(function () {
          // clear.js keeps discount codes, so a code from an earlier card would stack with this one:
          // replace the cart's codes with just this card's code (empty string removes them all)
          if (fresh) return fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ discount: code }) }).then(ok);
        })
        .then(function () {
          var dest = after === 'cart' ? '/cart' : '/checkout';
          // Without a fresh cart, Shopify's /discount/<code> adds the card's code alongside any existing ones
          window.location.href = code && !fresh ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest) : dest;
        })
        .catch(function (j) { cta.removeAttribute('aria-busy'); cta.disabled = false; if (err) err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please try again.'; });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rsb]').forEach(initBanner);
    (scope || document).querySelectorAll('[data-rph]').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
